import React, { useState } from "react";
import styles from './apppay.module.css';
import Helmet from "react-helmet";
import { Parallax, Background } from 'react-parallax';
import { DollarSign, Edit, Link } from "react-feather";
import { Link as Linkto, useHistory, useLocation } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Checkbox, FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import Page404 from "../../auth/Page404";
import Loader from "../../../components/Loader";
import axios from 'axios';
import { useEffect } from "react";
import { SmartToaster, toast } from "react-smart-toaster";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from "react-hook-form";
import { Elements, PaymentElement, PaymentRequestButtonElement, useElements, useStripe } from "@stripe/react-stripe-js";
import NumberFormat from "react-number-format";
import Autocomplete from "react-google-autocomplete";
import { forwardRef } from "react";
import dayjs from "dayjs";
import { useRef } from "react";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY_FC);

const MoneyField = forwardRef((props, ref) => {
    return <NumberFormat prefix="" displayType="input" type="text" thousandSeparator={true} allowNegative={false} decimalScale={2} fixedDecimalScale {...props} />;
});

const FiveDigitFieldformat = forwardRef((props, ref) => {
    return <NumberFormat prefix="" displayType="input" type="text" thousandSeparator={false} decimalScale={0} {...props} />;
});

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const PaymentForm = ({ totalCharge }) => {
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: process.env.REACT_APP_BASE_URL + "/tenant-payment-success",
            },
        });

        if (error) {
            alert(error.message);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement />
            <button className={`${styles.RentallAppliSubmitBU}`} type="submit" disabled={!stripe}>Pay ${totalCharge.toLocaleString('en', { minimumFractionDigits: 2 })}</button>
        </form>
    );
}

const AppPay = ({ history, match }) => {
    const { token } = match.params;
    const [loading, setLoading] = useState(true);
    const [isNotExist, setIsNotExist] = useState(false);
    const [propertyDet, setPropertyDet] = useState({});
    const [tenantDet, setTenantDet] = useState({});
    const [tenantDet2, setTenantDet2] = useState(null);
    const [amountType, setAmountType] = useState('');
    const [showBillingInfo, setShowBillingInfo] = useState(false);
    const [isSecondPaymentStep, setIsSecondPaymentStep] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const [fcCustomerId, setFCCustomerId] = useState('');
    const [connectedAccounts, setConnectedAccounts] = useState([]);
    //const navigate = useHistory();
    const stripe = useStripe();
    const queryP = useQuery();
    //const deviceType = queryP.get("id");
    const [clientSecret, setClientSecret] = useState(null);
    const elementContainer = useRef(null);
    const paymentElementRef = useRef(null);
    const stripeRef = useRef();
    const elementsRef = useRef();

    const schema = yup.object().shape({
        amount_type: yup.mixed().required('This field is Required'),
        amount: yup.string().required('This field is Required'),
        description: yup.string().required('This field is Required').max(200, 'Description cannot be more than 200 characters'),
        full_name: yup.string().required('This field is Required').max(50, 'Full name cannot be more than 50 characters'),
        email: yup.string().required('This field is reuired').email('Invalid E-mail'),
        address: yup.string(),
        address2: yup.string().max(50, 'Address 2 cannot be more than 50 characters'),
        city: yup.string(),
        state: yup.string(),
        zip: yup.string(),
        term_cond: yup.boolean().required('This field is Required').test('is-agree', 'This field is Required', (value, context) => value === true)
    });

    const { register, handleSubmit, control, errors, setValue, getValues, clearErrors } = useForm({
        resolver: yupResolver(schema), mode: 'onChange'
    });

    useEffect(() => {
        axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/check-tenant-payment-token/' + token).then(response => {
            let resData = response.data.data;
            setLoading(false);
            if (resData.property_id) {
                getPropertyInfo(resData.property_id);
            }

            if (resData.tenant_id) {
                getTenantInfo(resData.tenant_id);
            }

            if (resData.tenant_info_id) {
                getTenantInfoDet(resData.tenant_info_id);
            }

            if (resData.is_exist === 0) {
                setIsNotExist(true);
            }
        }).catch(error => {
            setLoading(false);
        });

        const getTenantInfo = async (id) => {
            await axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/tenant-payment-info/' + id).then(response => {
                let resData = response.data.data;
                setTenantDet(resData);

                setValue('address', resData?.address);
                setValue('address2', resData?.address2);
                setValue('city', resData?.city);
                setValue('zip', resData?.zip);
                setValue('state', resData?.state);

                setValue('addressnew', resData.address + ', ' + resData.city + ', ' + resData.state + ' ' + resData.zip);

                if (resData.balance2 <= 0) {
                    setTimeout(() => {
                        setValue('amount_type', 'other_amount');
                    }, 100);
                }
            });
        }

        const getTenantInfoDet = async (id) => {
            await axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/tenant-payment-info-det/' + id).then(response => {
                let resData = response.data.data;
                setTenantDet2(resData);

                setValue('full_name', resData?.full_name);
                setValue('email', resData?.email);
            });
        }
    }, [token, setValue]);

    const getPropertyInfo = async (id) => {
        await axios.get(process.env.REACT_APP_APPLICANT_API_URL + 'v1/application/property-det/' + id).then(response => {
            const resData = response.data.propertyDet;
            setPropertyDet(resData);
        })
    }

    const onSubmit = async (data) => {
        let amount = data.amount.replace(/,/g, '');
        amount = parseFloat(amount);

        setPaymentData({ total_amount: amount, description: data?.description, amount: amount, rentRollId: tenantDet?.last_rent_roll_id, tenantId: tenantDet?.id, tenantInfoId: tenantDet2?.id, cus_name: data?.full_name, cus_email: data.email, cus_phone: tenantDet2?.phone, cus_addr1: data?.address, cus_addr2: data?.address2, cus_city: data?.city, cus_state: data.state, cus_zip: data.zip });

        setIsSecondPaymentStep(true);
    }

    const onPlaceSelected = (place) => {
        let address = "";
        let city = "";
        let state = "";
        let postcode = "";

        for (let component of place.address_components) {
            let componentType = component.types[0];
            switch (componentType) {
                case "street_number": {
                    address = component.long_name;
                    break;
                }
                case "route": {
                    address += ' ' + component.short_name;
                    break;
                }
                case "postal_code": {
                    postcode = component.long_name;
                    break;
                }
                case "locality":
                    city = component.long_name;
                    break;
                case "sublocality_level_1":
                    city = component.long_name;
                    break;
                case "administrative_area_level_3":
                    city = component.long_name;
                    break;
                case "administrative_area_level_1": {
                    state = component.short_name;
                    break;
                }
                default:
                    break;
            }
        }

        setValue('address', address);
        setValue('city', city);
        setValue('state', state);
        setValue('zip', postcode);
    }

    useEffect(() => {
        if (tenantDet2?.id) {
            axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/connected-accounts/' + tenantDet2?.id).then(response => {
                setConnectedAccounts(response.data.data);
            })
        }
    }, [tenantDet2]);

    useEffect(() => {
        console.log('Connected Accounts');
        console.log(connectedAccounts);

        if (connectedAccounts.length > 0) {
            setFCCustomerId(connectedAccounts[0]?.fc_customer_id);
        }
    }, [connectedAccounts]);

    useEffect(() => {
        console.log('Connected fcCustomerId');
        console.log(fcCustomerId);
    }, [fcCustomerId]);

    useEffect(() => {
        if (isSecondPaymentStep && paymentData) {
            axios.post(process.env.REACT_APP_PAYMENT_API_URL + 'v1/create-payment-intent', { total_amount: paymentData?.amount, description: paymentData?.description, cus_name: paymentData?.cus_name, cus_phone: paymentData?.cus_phone, rentRollId: paymentData?.rentRollId, tenantId: paymentData?.tenantId, tenantInfoId: paymentData?.tenantInfoId }).then(async (result) => {
                console.log(result.data.clientSecret);
                setClientSecret(result.data.clientSecret);

                let paymentAuthData = { tenantId: paymentData?.tenantId, amount: paymentData?.amount?.toFixed(2) };
                localStorage.setItem("paymentAuthData", JSON.stringify(paymentAuthData));
            }).catch((error) => { });
        }

    }, [isSecondPaymentStep, paymentData]);

    const elements = useElements();

    useEffect(() => {
        if (elements && clientSecret) {
            elements.update({
                clientSecret,
                appearance: {}, // optional
            });
        }
    }, [elements, clientSecret]);

    return (<>
        {loading && <Loader />}
        {isNotExist && <Page404 />}

        {(!isNotExist) && <>
            <Helmet title="Payment" />

            <Parallax strength={300} className="RentalParallax">
                <Background className="custom-bg">
                    <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
                </Background>
            </Parallax>

            <div className="WhiteBG">
                <div className={`${styles.RentalAppliArea}`}>
                    <div className={`${styles.RentalAppliHead}`}>
                        {(tenantDet?.theme_options?.image_url !== '') && <img src={tenantDet?.theme_options?.image_url} alt="logo" />}
                        {(tenantDet?.theme_options?.image_url === '') && <img src={'/static/img/logo.svg'} alt="logo" />}
                        <p className={`${styles.RentalAppliHeadTitle}`}>{propertyDet?.name}</p>
                        <p className={`${styles.RentalAppliHeadTitle}`}>Rent Payment</p>
                    </div>

                    <div className={`${styles.ApplicantSec}`}>
                        <p className={`${styles.ApplicantSecTitle}`}>{tenantDet?.balancestr}</p>
                        <p className={`${styles.ApplicantSecSubTitle}`}>{(tenantDet?.balance2 < 0) ? 'Over Paid' : 'Balance Due'}</p>


                        {!isSecondPaymentStep && <form onSubmit={handleSubmit(onSubmit)}>
                            {(tenantDet?.balance2 <= 0) && <input type="hidden" name="amount_type" ref={register} />}

                            <div className={`${styles.PayNowSec}`}>
                                <div className={`${styles.BillingInfoTSection}`}>
                                    <p className={`${styles.PayNowSecTitle}`}>Payment information</p>
                                </div>

                                {(tenantDet?.balance2 > 0) && <div className={`${styles.ToggleBUFull}`}>
                                    <label className={`${styles.FormLabel}`} >Payment amount*</label>
                                    <div className={`${styles.CusRadioRow}`}>
                                        <label className={`${styles.CusRadio}`}>
                                            <input type="radio" name="amount_type" ref={register} control={control} value="total_due" onChange={e => { console.log(1111); console.log(tenantDet.balance2); setAmountType('total_due'); setValue("amount", tenantDet.balance2); clearErrors(['amount_type', 'amount']); }} />
                                            <div className={`${styles.checkmark}`}>Full balance</div>
                                        </label>
                                        <label className={`${styles.CusRadio}`}>
                                            <input type="radio" name="amount_type" ref={register} control={control} value="other_amount" onChange={e => { console.log(222222); setAmountType('other_amount'); setValue("amount", ''); clearErrors(['amount_type', 'amount']); }} />
                                            <div className={`${styles.checkmark}`}>Other amount</div>
                                        </label>
                                        {errors.amount_type && <p className={`${styles.ErrorM2}`}>{errors.amount_type.message}</p>}
                                    </div>
                                </div>}

                                <div className={`${styles.FormGroupHalf} ${styles.Dollar}`}>
                                    <label className={`${styles.FormLabel}`} >Amount*</label>
                                    <div className={`${styles.Width100}`}>
                                        <p className={`${styles.AccoDollarSign}`}><DollarSign /></p>
                                        <Controller
                                            name="amount"
                                            render={({ onChange, value }) => (<MoneyField className={`${styles.formControl}`} value={value} onChange={(value) => { onChange(value); }} placeholder="0.00" readOnly={amountType === "total_due"} />)}
                                            control={control}
                                            ref={register}
                                            className={`${styles.formControl}`}
                                        />
                                        {errors.amount && <p className={`${styles.ErrorM2}`}>{errors.amount.message}</p>}
                                    </div>
                                </div>

                                <div className={`${styles.FormGroupHalf}`}>
                                    <label className={`${styles.FormLabel}`} >Memo*</label>
                                    <div className={`${styles.Width100}`}>
                                        <input className={`${styles.formControl}`} type="text" name="description" ref={register} />
                                        {errors.description && <p className={`${styles.ErrorM2}`}>{errors.description.message}</p>}
                                    </div>
                                </div>

                            </div>

                            <div className={`${styles.PayNowSec}`}>
                                <div className={`${styles.BillingInfoTSection}`}>
                                    <p className={`${styles.PayNowSecTitle}`}>Billing Contact & address</p>
                                    {!showBillingInfo && <button className={`${styles.EditBillingBU}`} onClick={() => { setShowBillingInfo(!showBillingInfo); }}><Edit /></button>}
                                </div>

                                {!showBillingInfo && <div className={`${styles.BillingInfoTextSec}`}>
                                    <p className={`${styles.BillingTextList}`}>{tenantDet2?.full_name}</p>
                                    <p className={`${styles.BillingTextList}`}>{tenantDet2?.email}</p>
                                    <p className={`${styles.BillingTextList}`}>{tenantDet?.address}, {tenantDet?.address2}<br />{tenantDet?.city}, {tenantDet?.state} {tenantDet?.zip}</p>
                                </div>}

                                <div className={!showBillingInfo ? `${styles.BillingInfoFormSec} ${styles.BillingInfoFormSecHide}` : `${styles.BillingInfoFormSec}`}>
                                    <div className={`${styles.FormGroupHalf}`}>
                                        <label className={`${styles.FormLabel}`} >Full name*</label>
                                        <div className={`${styles.Width100}`}>
                                            <input className={`${styles.formControl}`} placeholder="Full Name" type="text" name="full_name" ref={register} />
                                            {errors.full_name && <p className={`${styles.ErrorM}`}>{errors.full_name.message}</p>}
                                        </div>
                                    </div>
                                    <div className={`${styles.FormGroupHalf}`}>
                                        <label className={`${styles.FormLabel}`} >Email*</label>
                                        <div className={`${styles.Width100}`}>
                                            <input className={`${styles.formControl}`} placeholder="example@gmail.com" type="email" name="email" ref={register} />
                                            {errors.email && <p className={`${styles.ErrorM}`}>{errors.email.message}</p>}
                                        </div>
                                    </div>

                                    <div className={`${styles.FormGroupFull}`}>
                                        <label className={`${styles.FormLabel}`} >Address*</label>
                                        <div className={`${styles.Width100}`}>
                                            <Controller
                                                className={`${styles.formControl}`}
                                                render={(field) => (<Autocomplete
                                                    name="addressnew"
                                                    ref={register}
                                                    className={`${styles.formControl}`}
                                                    apiKey={process.env.REACT_APP_MAP_API_KEY}
                                                    options={{
                                                        types: ["address"],
                                                        componentRestrictions: { country: "us" },
                                                        fields: ["address_components", "geometry"],
                                                    }}
                                                    onPlaceSelected={onPlaceSelected}
                                                    defaultValue={field?.value ? field?.value : ''}
                                                    onChange={(e) => field.onChange(e)} />)}
                                                name="addressnew"
                                                control={control}
                                                autoComplete="off"
                                                type="text"
                                            />
                                            <input className={`${styles.formControl}`} placeholder="Address" type="hidden" name="address" ref={register} />
                                            {errors.address && <p className={`${styles.ErrorM}`}>{errors.address.message}</p>}
                                        </div>
                                    </div>

                                    <div className={`${styles.FormGroupFull}`}>
                                        <label className={`${styles.FormLabel}`} >Address line 2</label>
                                        <div className={`${styles.Width100}`}>
                                            <input className={`${styles.formControl}`} placeholder="Address line 2" type="text" name="address2" ref={register} />
                                        </div>
                                    </div>

                                    <div className={`${styles.FormGroupHalf} ${styles.FormGroupHalfHide}`}>
                                        <label className={`${styles.FormLabel}`} >City*</label>
                                        <div className={`${styles.Width100}`}>
                                            <input className={`${styles.formControl}`} placeholder="City" type="text" name="city" ref={register} />
                                            {errors.city && <p className={`${styles.ErrorM}`}>{errors.city.message}</p>}
                                        </div>
                                    </div>
                                    <div className={`${styles.FormGroupHalf} ${styles.FormGroupHalfHide} CusSelect`}>
                                        <label className={`${styles.FormLabel}`} >State</label>
                                        <div className={`${styles.Width100}`}>
                                            <input className={`${styles.formControl}`} placeholder="State" type="text" name="state" ref={register} />
                                            {errors.state && <p className={`${styles.ErrorM}`}>{errors.state.message}</p>}
                                        </div>
                                    </div>

                                    <div className={`${styles.FormGroupHalf} ${styles.FormGroupHalfHide}`}>
                                        <label className={`${styles.FormLabel}`} >Zip code*</label>
                                        <div className={`${styles.Width100}`}>
                                            <Controller className={`${styles.formControl}`} as={<FiveDigitFieldformat format="#####" />} placeholder="Zip code" control={control} name="zip" ref={register} />
                                            {errors.zip && <p className={`${styles.ErrorM}`}>{errors.zip.message}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className={`${styles.FormGroupFull}`}>
                                    <label className={`${styles.FormLabel}`} >Terms and Conditions</label>
                                    <div className={`${styles.TermsTextSec}`}>
                                        <p>I authorize the debit of my checking/ savings account for the amount indicated above. I understand that because this is an electronic transaction, these funds may be withdrawn from my account immediately. If payment is rejected for Non-Sufficient Funds (NSF), I understand that another attempt to process the charge will be made in 30 days, and I agree to an additional $25 charge for each attempt returned NSF, which will be initiated as a separate transaction from the authorized payment.</p>
                                        <FormControlLabel
                                            label={"I agree to the terms and conditions"}
                                            control={
                                                <Controller
                                                    ref={register}
                                                    name="term_cond"
                                                    control={control}
                                                    render={(field) => <Checkbox {...field} onChange={(e) => field.onChange(e.target.checked)} />}
                                                />
                                            }
                                        />
                                    </div>
                                    {errors.term_cond && <span className={`${styles.TermErrorMM}`}>{errors?.term_cond?.message}</span>}
                                </div>
                            </div>

                            <button type="submit" className={`${styles.RentallAppliSubmitBU}`}>Continue</button>
                        </form>}

                        {isSecondPaymentStep && paymentData && <div className={`${styles.PayNowSec}`}>
                            {clientSecret && (
                                <Elements stripe={stripePromise} options={{ clientSecret }}>
                                    <PaymentForm totalCharge={paymentData?.amount} />
                                </Elements>
                            )}
                        </div>}
                    </div>
                </div>

                <div className={`${styles.FooterWrap}`}>
                    <div className={`${styles.footerMain}`}>

                        <div className={`${styles.footerMainLeft}`}>
                            {(tenantDet?.theme_options?.image_url !== '') && <Linkto to={'/'}><img src={tenantDet?.theme_options?.image_url} alt="logo" /></Linkto>}
                            {(tenantDet?.theme_options?.image_url === '') && <Linkto to={'/'}><img src={'/static/img/logo.svg'} alt="logo" /></Linkto>}
                        </div>

                        <div className={`${styles.footerMainRight}`}>
                            <div>
                                <h3>CONTACT US</h3>
                                <ul>
                                    <li><a href={"mailto:" + propertyDet?.email}>{propertyDet?.email}</a></li>
                                    <li><a href={"mailto:" + propertyDet?.phone}>{propertyDet?.phone}</a></li>
                                </ul>
                            </div>
                            <div>
                                <h3>FIND US</h3>
                                <ul>
                                    <li>{propertyDet?.address} <br />{propertyDet?.city}, {propertyDet?.state} {propertyDet?.zip}</li>
                                </ul>
                            </div>
                            <div>
                                <h3>LEGAL</h3>
                                <ul>
                                    <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                    <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li>PropertyDek © {dayjs().format("YYYY")}.<br />All rights reserved.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>}

        <SmartToaster
            store={toast}
            lightBackground={true}
            position={"top_center"}
        />
    </>);
}

export default AppPay;
